<div class="flex flex-row justify-between items-center">
  @if (showBackButton) {
    <button mat-icon-button (click)="backEvent.emit()">
      <mat-icon>arrow_back</mat-icon>
    </button>
  } @else {
    <div>&nbsp;</div>
  }
  <p class="text-3xl sm:text-xl font-semibold">{{ title }}</p>

  <div class="flex items-center gap-1">
    @if (showCollapseButton) {
      <button mat-icon-button (click)="collapseEvent.emit()">
        <mat-icon>arrow_forward</mat-icon>
      </button>
    }
    @if (showCloseButton) {
      <button mat-icon-button (click)="closeEvent.emit()">
        <mat-icon>close</mat-icon>
      </button>
    } @else {
      <div>&nbsp;</div>
    }
  </div>
</div>
